<template>
  <li v-if="hidden !== true && this.model.hidden !== true" :class="[isFolder ? 'folder' : 'file']">
    <label
      :class="{'open': open || (this.model.need_open && this.model.need_open === true )  }"
      :style="`padding-left: ${model.level === 0 ? 18 : model.level * 36}px`"
      @click.self="toggle"
      >
      <span @click.self="toggle" class="title">
        <span v-if="model.type == 1" class="doc-description">{{this.model.description}}</span>
        <span v-if="this.model.type === 0" :class="open || (this.model.need_open && this.model.need_open === true ) ? 'model-name open' : 'model-name'" @click.self="toggle">{{model.name}}</span>
        <span @click="openAsset(model.asset)" v-else>{{model.name}}</span>
        <i :class="open || (this.model.need_open && this.model.need_open === true ) ? 'toggle-arrow open' : 'toggle-arrow'"></i>
      </span>
      <div class="icons-row">
        <i v-if="model.type == 0 && needAction" @click="addChildFolder" class="add-category">{{$t('app.documents.subfolder')}}</i>
        <i v-if="model.type == 0 && needAction" @click="addChildDocument" class="add-category">{{$t('app.documents.newDocument')}}</i>
        <i v-if="this.model.type === 1 && this.model.asset" @click="openAsset(model.asset)" class="zmdi zmdi-download action-button"></i>
        <i v-if="needAction" @click="editItem('edit')" class="zmdi zmdi-edit action-button"></i>
        <i v-if="needAction" @click="deleteItem" class="zmdi zmdi-delete action-button"></i>
      </div>
    </label>
    <ul v-show="open || (this.model.need_open && this.model.need_open === true )" v-if="isFolder" :class="{'open': open}">
      <item
        v-for="(model, index) in model.children"
        :key="index"
        :selectedIndex="index"
        :parentIndex="selectedIndex"
        :bus="bus"
        :isSearch="isSearch"
        :model="model"/>
      <item
        v-for="(model, index) in model.documents"
        :key="index+'_d' "
        :selectedIndex="index"
        :parentIndex="selectedIndex"
        :bus="bus"
        :isSearch="isSearch"
        :model="model"/>
    </ul>
  </li>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import GenericForm from '@/components/shared/forms/GenericForm';
import InfoPopUp from '@/components/modules/criteria_categories/InfoPopUp';

export default {
  name: 'item',
  components: {
    'info-popup': InfoPopUp,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    bus: {
      type: Object,
      required: false,
    },
    selectedIndex: {
      type: Number,
      required: false,
    },
    parentIndex: {
      type: Number,
      required: false,
    },
    isSearch: {
      type: Boolean,
      required: false,
    },
    searchType: {
      type: String,
      required: false,
    },
    needAction: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      hidden: false,
      open: false,
      newFolder: {
        name: undefined,
        parent_id: undefined,
        level: undefined,
      },
      newDocument: {
        name: undefined,
        description: undefined,
        owner_partner_id: undefined,
        file: undefined,
      },
      folderAttributes: [
        {
          name: 'name',
          type: 'text',
        },
      ],
    };
  },
  created() {
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'loggedInUser',
    }),
    needAction() {
      return this.loggedInUser.role === 'admin' || this.loggedInUser.role === 'partner_admin'
    },
    isFolder() {
      return this.model.children && this.model.children.length || this.model.type === 0;
    },
    documentAttributes() {
      if (this.loggedInUser.role === 'admin') {
        return [
          {
            name: 'name',
            type: 'text',
          },
          {
            name: 'description',
            type: 'text-area',
          },
          {
            name: 'file',
            type: 'file',
            multiple: false,
          },
        ];
      }
      return [
        {
          name: 'name',
          type: 'text',
        },
        {
          name: 'description',
          type: 'text-area',
        },
        {
          name: 'file',
          type: 'file',
          multiple: false,
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      createFolder: 'folders/createFolder',
      deleteFolder: 'folders/deleteFolder',
      updateFolder: 'folders/updateFolder',
      fetchFolder: 'folders/fetchFolder',
      fetchDocument: 'documents/fetchDocument',
      createNewDocument: 'documents/createDocument',
      updateDocumentParams: 'documents/updateDocument',
      deleteDocument: 'documents/deleteDocument',
    }),
    openAsset(url) {
      if (url && typeof url === 'string') {
        window.open(url, '_blank');
      } else {
        window.open(url.url, '_blank');
      }
    },
    toggle() {
      if (this.isFolder) {
        if (this.model.need_open) {
          this.model.need_open = false;
          this.open = false;
        } else {
          this.open = !this.open;
        }
      }
    },
    addChildFolder() {
      this.$eventBus.showModal({
        bind: {
          is: GenericForm,
          title: this.$t(
            'app.sub_folders.set_folder',
          ),
          fields: this.folderAttributes,
          model: this.newFolder,
          submitTitle: this.$t('app.verification_questions.buttons.save'),
          cancelTitle: this.$t('app.verification_questions.buttons.cancel'),
          modelName: 'sub_folders',
        },
        on: {
          submit: this.createNewFolder,
          modalCanceled: this.resetFolder,
        },
      });
    },
    addChildDocument() {
      this.$eventBus.showModal({
        bind: {
          is: GenericForm,
          title: this.$t('app.documents.set_document'),
          fields: this.documentAttributes,
          model: this.newDocument,
          submitTitle: this.$t('app.documents.buttons.save'),
          cancelTitle: this.$t('app.documents.buttons.cancel'),
          modelName: 'documents',
        },
        on: {
          submit: this.createDocument,
          modalCanceled: this.resetNewDocument,
        },
      });
    },
    deleteItem() {
      this.$swal
        .fire({
          html: this.$t('app.notifications.general_confirm.title'),
          type: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: this.$t('app.notifications.general_confirm.ok'),
          cancelButtonText: this.$t('app.notifications.general_confirm.cancel'),
        })
        .then((result) => {
          if (result.value) {
            if (this.model.type === 0) {
              this.deleteFolder(this.model.id).then((response) => {
                this.hidden = true;
                this.$eventBus.showNotification({
                  notificationText: this.$t('app.folders.delete'),
                  notificationType: 'success',
                });
              })
                .catch((error) => {
                  this.$eventBus.stopLoading();
                  this.$swal
                    .fire({
                      html: 'Egy mappa csak akkor törölhető, ha nem tartalmaz semmit!',
                      type: 'error',
                      showCloseButton: true,
                      showCancelButton: false,
                      showConfirmButton: false,
                      focusConfirm: false,
                    });
                });
            } else {
              this.deleteDocument(this.model.id)
                .then((response) => {
                  this.hidden = true;
                  this.$eventBus.showNotification({
                    notificationText: this.$t('app.documents.success.delete'),
                    notificationType: 'success',
                  });
                })
                .catch((error) => {
                  this.$swal
                    .fire({
                      html: error[0],
                      type: 'error',
                      showCloseButton: true,
                      showCancelButton: false,
                      showConfirmButton: false,
                      focusConfirm: false,
                    });
                });
            }
          }
        });
    },
    editItem(action) {
      if (this.model.type === 0) {
        this.fetchFolder(this.model.id).then((folder) => {
          this.$eventBus.showModal({
            bind: {
              is: GenericForm,
              title: this.model.parent_id ? this.$t(
                'app.sub_folders.update_folder') : this.$t(
                'app.folders.update_folder',
              ),
              fields: this.folderAttributes,
              model: folder,
              submitTitle: this.$t('app.verification_questions.buttons.save'),
              cancelTitle: this.$t('app.verification_questions.buttons.cancel'),
              modelName: 'sub_folders',
            },
            on: {
              submit: this.updateExistingFolder,
            },
          });
        });
      } else {
        this.fetchDocument(this.model.id)
          .then((response) => {
            this.$eventBus.showModal({
              bind: {
                is: GenericForm,
                title: this.$t('app.documents.edit_document'),
                fields: this.documentAttributes,
                model: response,
                submitTitle: this.$t('app.documents.buttons.save'),
                cancelTitle: this.$t('app.documents.buttons.cancel'),
                modelName: 'documents',
              },
              on: {
                submit: this.updateDocument,
              },
            });
          })
          .catch((error) => {
            const mappedErrors = error.map(x => ` ${x}`);
            const errorMessages = this.$t('app.errors.general_validation', {
              message: mappedErrors,
            });
            this.$swal
              .fire({
                html: errorMessages,
                type: 'error',
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false,
              });
          });
      }
    },
    createNewFolder(newFolder) {
      newFolder.level = this.model.level + 1;
      newFolder.parent_id = this.model.id;
      this.createFolder(newFolder).then((response) => {
        response.type = 0;
        if (this.model.children) {
          this.model.children.push(response);
        } else {
          this.model.children = [];
          this.model.children.push(response);
        }
        this.$eventBus.showNotification({
          notificationText: this.$t('app.folders.create'),
          notificationType: 'success',
        });
        this.resetFolder();
        this.$eventBus.hideModal();
      })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    updateExistingFolder(folder) {
      this.updateFolder(folder).then((response) => {
        this.model.name = response.name;
        this.$eventBus.hideModal();
      })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    resetFolder() {
      Object.assign(
        this.$data.newFolder,
        this.$options.data().newFolder,
      );
    },
    createDocument(newDocument) {
      newDocument.folder_id = this.model.id;
      this.createNewDocument(newDocument)
        .then((response) => {
          response.type = 1;
          response.level = this.model.level + 1;
          if (this.model.children) {
            this.model.children.push(response);
          } else {
            this.model.children = [];
            this.model.children.push(response);
          }
          this.resetNewDocument();
          this.$eventBus.hideModal();
          this.$eventBus.showNotification({
            notificationText: this.$t('app.documents.success.create'),
            notificationType: 'success',
          });
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    updateDocument(document) {
      this.updateDocumentParams(document)
        .then((response) => {
          this.model.name = response.name;
          this.model.description = response.description;
          this.model.asset = response.asset.url;
          this.$eventBus.hideModal();
          this.$eventBus.showNotification({
            notificationText: this.$t('app.documents.success.update'),
            notificationType: 'success',
          });
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    resetNewDocument() {
      Object.assign(this.$data.newDocument, this.$options.data().newDocument);
    },
  },
  watch: {
    isSearch(newValue, oldValue) {
      if (newValue === false) {
        this.open = newValue;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.doc-description {
  margin-left: 100px;
}
  label {
    display: flex !important;
    justify-content: space-between;
  }

  .icons-row {
    display: flex;
    align-items: center;
  }

  .model-id, .model-name {
    float: left !important;
    margin-right: 60px;
  }

  span.title > span.model-name::before {
    content: "\f054";
  }

  span.title > span.model-name::before {
    font: normal normal normal 14px/1 FontAwesome;
    left: 8px;
    margin-right: 10px;
    transform: translateY(-50%);
    transition: transform 0.3s;
  }

  span.title > span.model-name.open::before {
    font-family: 'Glyphicons Halflings';
    content: "\e114";
  }

  .action-button {
    cursor: pointer;
    margin-left: 30px;
    margin-top: 3px;
  }

  .add-question,
  .add-category {
    cursor: pointer;
    margin-left: 40px;
    font-size: 14px;
    font-weight: 500;
  }
  .add-question {
    margin-left: 80px;
    margin-right: 80px;
  }

  .add-question:before,
  .add-category:before {
    font: normal normal normal 14px/1 FontAwesome;
    left: 18px;
    content: "\f067";
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/documents/DocumentItem.vue